// ===========================================
// JOB BODY - "Export as PDF" opens the print dialog (Save as PDF).
// Print layout: assets/scss/partials/_print.scss
// ===========================================

document.addEventListener("click", function (event) {
  if (event.target.closest("[data-print]")) {
    window.print();
  }
});
